<template>
  <div>
    <v-container grid-list-md>
      <v-layout wrap style="direction:rtl">
        <v-flex
          v-if="permissions.barnch_sales_report == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/BranchSalesReport')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              تقرير شامل فرع
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.company_sales_report == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/CompanySalesReport')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              تقرير شامل شركة
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.branch_madionia_report == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/BranchMadioniaReport')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              تقرير مديونيات فرع
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex
          v-if="permissions.user_behavior_report == 1 || user.type == 1"
          xs12
          sm6
          md6
        >
          <v-card
            @click="$router.push('/UserBehaviorReport')"
            elevation="20"
            style="max-width:95%;margin-bottom: 5%;padding:20px;background-color:#8be726;border-radius:20px;color:blue;cursor: pointer;"
          >
            <v-card-title
              style="margin:auto;font-size:40px;font-weight: bold;"
              class="align-center fill-height justify-center"
            >
              <img
                style="width:40px;height:30px;margin:0 10px"
                src="../../../public/images/pharma_logo.jpg"
                alt="aa"
              />
              تقرير الحركة للسيستم
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
  }
};
</script>
